<template>
  <v-container fluid class="home-container pa-0">
    <section>
      <v-row>
        <v-carousel hide-delimiters class="carousel-home">
          <v-carousel-item
            v-for="(slide, i) in carousel"
            :key="i"
            :src="slide.upload.path"
            class="carousel-item"
          >
            <v-container class="d-flex my-lg-5" :class="slide.position">
              <v-row class="px-lg-6 px-16 d-flex" :class="slide.position">
                <v-col cols="12" lg="5">
                  <h2 class="text-lg-h2 text-h4 text-white font-weight-bold mb-lg-5"
                  :style="'color:#'+ slide.color + '!important'"
                  >
                    {{ slide.title }}
                  </h2>
                  <h4 class="text-lg-h4 text-h5 text-white font-weight-bold"
                   :style="'color:#'+ slide.color+ '!important'"
                   v-html="slide.description"
                  >
                    
                  </h4>
                </v-col>
              </v-row>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-row>
    </section>

    <section class="pt-lg-16 pb-lg-0 py-10 py-sm-14">
      <v-container class="pt-lg-16 px-10 px-sm-14 pt-16 px-lg-3">
        <v-row>
          <v-col cols="12" lg="6">
            <h3
              class="text-lg-h3 text-h5 text-sm-h4 text-navy font-weight-bold"
              v-html="$t('home.testimonialsOfOurPatients')"
            ></h3>
          </v-col>
        </v-row>
        <v-row>
          <v-carousel
            hide-delimiters
            class="carousel-testimonials d-none d-lg-flex flex-column"
          >
            <v-carousel-item v-for="(testimony, i) in testiomies" :key="i">
              <v-container class="d-lg-flex flex-column justify-center">
                <v-row class="justify-lg-center align-lg-center">
                  <v-col cols="12" lg="8" class="py-0">
                    <v-card
                      class="mx-auto background-odd rounded-lg elevation"
                      max-width="770"
                    >
                      <v-row class="ma-0">
                        <v-col cols="12" sm="4" class="pa-0">
                          <v-img
                            :src="testimony.upload.path"
                            max-height="370"
                            height="100%"
                            class="rounded-tl-lg rounded-bl-lg d-none d-sm-flex"
                          ></v-img>
                          <v-img
                            :src="testimony.upload.path"
                            max-height="370"
                            height="100%"
                            class="rounded-tl-lg rounded-tr-lg d-sm-none"
                          ></v-img>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="8"
                          class="
                            px-lg-10
                            d-flex
                            flex-column
                            justify-center
                            py-lg-16
                          "
                        >
                          <v-card-title class="text-navy text-lg-h4 px-lg-0"
                            ><b> {{ testimony.name }}</b
                            >, {{ testimony.age }}
                          </v-card-title>

                          <v-card-subtitle class="text-navy text-lg-h6 px-lg-0">
                            {{ $t("home.condition") }}:
                            {{ testimony.pathology.name[$i18n.locale] }}
                          </v-card-subtitle>

                          <p class="text-navy text-lg-h6 font-weight-light">
                            {{ testimony.message }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-carousel-item>
          </v-carousel>
          <v-carousel
            :show-arrows="false"
            :hide-delimiters="false"
            hide-delimiter-background
            class="carousel-testimonials d-lg-none mt-5 mt-sm-10"
          >
            <v-carousel-item v-for="(testimony, i) in testiomies" :key="i">
              <v-container class="d-lg-flex flex-column justify-center">
                <v-row class="justify-lg-center align-lg-center">
                  <v-col cols="12" lg="8" class="py-0">
                    <v-card
                      class="mx-auto background-odd rounded-lg elevation"
                      max-width="770"
                    >
                      <v-row class="ma-0">
                        <v-col cols="12" sm="4" class="pa-0">
                          <v-img
                            :src="testimony.upload.path"
                            max-height="370"
                            height="100%"
                            class="rounded-tl-lg rounded-bl-lg d-none d-sm-flex"
                          ></v-img>
                          <v-img
                            :src="testimony.upload.path"
                            max-height="370"
                            height="100%"
                            class="rounded-tl-lg rounded-tr-lg d-sm-none"
                          ></v-img>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="8"
                          class="
                            px-10
                            d-flex
                            flex-column
                            justify-center
                            py-lg-16
                          "
                        >
                          <v-card-title class="text-navy text-lg-h4 px-0"
                            ><b> {{ testimony.name }}</b
                            >, {{ testimony.age }}
                          </v-card-title>

                          <v-card-subtitle class="text-navy text-lg-h6 px-0">
                            {{ $t("home.condition") }}:
                            {{ testimony.pathology.name[$i18n.locale] }}
                          </v-card-subtitle>

                          <p class="text-navy text-lg-h6 font-weight-light">
                            {{ testimony.message }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-carousel-item>
          </v-carousel>
        </v-row>
      </v-container>
    </section>
    <section class="" v-if="selectedEvent">
      <v-container class="px-10 px-sm-14 px-lg-3 pt-10 py-lg-3">
        <v-row>
          <v-col cols="12" lg="6">
            <h3
              class="text-lg-h3 text-h5 text-sm-h4 text-navy font-weight-bold"
              v-html="$t('home.eventAndActivities')"
            ></h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="5" class="d-flex align-center">
            <v-sheet
              class="border-navy rounded-lg"
              width="100%"
              max-height="465"
              height="100%"
            >
              <v-toolbar flat class="rounded-lg justify-center d-flex">
                <v-btn fab text small class="text-green mr-lg-6" @click="prev">
                  <v-icon> mdi-chevron-left </v-icon>
                </v-btn>

                <v-toolbar-title v-if="$refs.calendar" class="calendar-month">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-btn fab text small class="text-green ml-lg-6" @click="next">
                  <v-icon> mdi-chevron-right </v-icon>
                </v-btn>
              </v-toolbar>
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                event-color="transparent"
                :locale="lang"
                type="month"
                @click:date="viewDay"
                class="rounded-lg"
                v-bind:show-month-on-first="false"
              ></v-calendar>
            </v-sheet>
          </v-col>
          <v-col cols="12" lg="6" >
            <v-img
              :src="selectedEvent.upload.path"
              class="rounded-lg"
              height="285"
            ></v-img>
            <v-row class="ma-0">
              <h6
                class="text-body-1 mt-4 event-date"
                v-if="selectedEvent !== ''"
              >
                {{ moment(selectedEvent.start).format("LL") }}
              </h6>
            </v-row>
            <h5 class="text-navy text-lg-h5 font-weight-bold mt-lg-2">
              {{ selectedEvent.name }}
            </h5>
            <p class="text-navy font-weight-light">
              {{ selectedEvent.description }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="py-lg-16 pt-10 pt-sm-14">
      <v-container class="py-lg-16 px-10 px-sm-14 px-lg-3">
        <v-row>
          <v-col cols="12" lg="6">
            <h3
              class="text-lg-h3 text-h5 text-sm-h4 text-navy font-weight-bold"
              v-html="$t('home.lastNews')"
            ></h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            lg="4"
            class="d-flex justify-center flex-column align-center pb-10 pb-lg-3"
            v-for="(newItem, index) in news.slice(0, num)"
            :key="index"
          >
            <v-card
              class="mx-auto background-green-light elevation-0 rounded-lg"
              max-width="364"
              width="100%"
            >
              <v-img :src="newItem.upload.path" height="300"></v-img>

              <v-card-subtitle
                class="text-white text-lg-body-1 font-weight-bold"
              >
                 {{ moment(newItem.publication_date).format("LL") }}
              </v-card-subtitle>
              <v-card-title class="text-white text-lg-h6 font-weight-bold mt-n7 line-limit-2 "
                >{{ newItem.title }}
              </v-card-title>
            </v-card>
            <v-btn
              class="
                elevation-0
                mt-lg-10 mt-5
                btn-first
                text-capitalize text-lg-h6
                font-weight-bold
              "
              outlined
              width="200"
              :to="`/news/${newItem.slug}`"
            >
              {{ $t("home.keepReading") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="pb-lg-16 pt-10 pt-sm-14 pt-lg-0">
      <v-container class="px-10 px-sm-14 px-lg-3">
        <v-row class="my-lg-0">
          <v-col cols="12" lg="6">
            <h3
              class="text-lg-h3 text-h5 text-sm-h4 text-navy font-weight-bold"
              v-html="$t('home.whereToFindUs')"
            ></h3>
          </v-col>
        </v-row>
      </v-container>
      <map-component @addressUpdated="newValue => address = newValue"></map-component>
      <v-container>
        <v-row class="my-lg-0 justify-lg-center pa-10 pa-sm-14 py-lg-0 px-lg-3">
          <v-col cols="12" sm="6" lg="3">
            <v-img
              src="/telefonofilled.svg"
              width="45"
              class="mx-auto my-lg-3"
            ></v-img>
            <h6 class="text-h6 text-navy font-weight-bold text-center">
              {{address.number}}
            </h6>
          </v-col>
          <v-col cols="12" lg="3">
            <v-img
              src="/posicion.svg"
              width="45"
              class="mx-auto my-lg-3"
            ></v-img>
            <h6 class="text-h6 text-navy font-weight-bold text-center">
              {{ $t("home.headquarters") }}{{ " "+ address.name}}:<br />
              {{address.address}}
            </h6>
          </v-col>
            <v-col cols="12" lg="3">
            <v-img
              src="/icon-clock.svg"
              width="45"
              class="mx-auto my-lg-3"
            ></v-img>
            <h6 class="text-h6 text-navy font-weight-bold text-center" v-html="$t('home.schedule')">
             
            </h6>
          </v-col>
           <v-col cols="12" sm="6" lg="3">
            <v-img src="/mail.svg" width="50" class="mx-auto my-lg-3"></v-img>
            <h6 class="text-h6 text-navy font-weight-bold text-center">
              info@incocegla.org.do
            </h6>
          </v-col>
        </v-row>
      </v-container>
      <schedule-an-appointment></schedule-an-appointment>
    </section>
  </v-container>
</template>

<script>
import scheduleAnAppointment from "../components/scheduleYourAppointment.vue";
import mapComponent from "../components/map.vue";
import Carousel from "../services/carousel";
import Testimony from "../services/testimony";
import New from "../services/new";
import $ from "jquery";
import EventService from "@/services/event";

export default {
  name: "Home",
  components: {
    mapComponent,
    scheduleAnAppointment,
  },
  async created() {
    this.carousel = await Carousel.getCarousel();
    this.testiomies = await Testimony.getTestimonies();
    this.news = await New.getNews();
    this.events = await EventService.getEvents();
    this.getEvent();
  
  },
 
  data() {
    return {
      carousel: [],
      testiomies: [],
      news: [],
      focus: "",
      type: "month",
      selectedEvent: null,
      month: new Date().getFullYear(),
      lang: localStorage.getItem("lang"),
      events: [],
      address: "",
    };
  },
  computed: {
    num() {
      if (window.innerWidth < 1264) {
        return 2;
      }
      return 3;
    },
  },

  methods: {
    viewDay({ date }) {
      let event = this.events.find((event) => event.start === date);
      if (event) {
        this.selectedEvent = event;
      }
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getEvent() {
      this.selectedEvent = this.events.find(
        (event) =>
          this.moment(event.start).isSameOrAfter(this.moment())
      );
    },
  },
  watch: {
    events() {
      this.$nextTick(() => {
        $(".v-calendar-weekly__day.v-future")
          .has(".v-event")
          .addClass("has-event");
      });
    },
  
  },
};
</script>
